<h2 mat-dialog-title>Filter Delivery Date</h2>

<mat-dialog-content class="dialog-body">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Filter Type</mat-label>
    <mat-select [(ngModel)]="operator">
      @for (opt of filterOptions; track opt) {
      <mat-option [value]="opt">
        {{ formatLabel(opt) }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (operator !== 'inRange') {
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Date</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [(ngModel)]="from"
      placeholder="Select date"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  } @if (operator === 'inRange') {
  <div class="range-container">
    <mat-form-field appearance="outline">
      <mat-label>From</mat-label>
      <input matInput [matDatepicker]="fromPicker" [(ngModel)]="from" />
      <mat-datepicker-toggle
        matSuffix
        [for]="fromPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>To</mat-label>
      <input matInput [matDatepicker]="toPicker" [(ngModel)]="to" />
      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
    </mat-form-field>
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onClear()">Clear</button>
  <button mat-flat-button color="primary" (click)="onApply()">Apply</button>
</mat-dialog-actions>
